import { LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

export const UploadManagerStatus = ({
  status,
  progress,
  message,
}: {
  status: 'pending' | 'completed' | 'failed';
  progress?: number;
  message?: string;
}) => {
  switch (status) {
    case 'pending':
      return (
        <ProgressWrapper>
          <LinearProgress
            variant={
              typeof progress === 'number' ? 'determinate' : 'indeterminate'
            }
            {...(typeof progress === 'number' ? { value: progress } : {})}
          />
        </ProgressWrapper>
      );
    case 'completed':
      return (
        <FormattedMessage
          id="uploadComplete"
          defaultMessage="Upload complete"
        />
      );
    case 'failed':
      // The batch message explains that nothing was saved; a bare "Failed to upload" would let
      // the user assume only this one file was affected.
      return message ? (
        <FailureText>{message}</FailureText>
      ) : (
        <FormattedMessage
          id="failedToUpload"
          defaultMessage="Failed to upload"
        />
      );
  }
};

const FailureText = styled('div')({
  whiteSpace: 'normal',
  wordBreak: 'break-word',
});

const ProgressWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: 20,

  '> span': {
    width: '100%',
  },
});
